import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import './i18n';  // Import the i18n configuration
import RTLProvider from './components/RTLProvider';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Textile from './pages/Textile';
import Ambalaj from './pages/Ambalaj';
import Ticaret from './pages/Ticaret';
import Catalog from './pages/Catalog';
import './App.css';

function App() {
  return (
    <Suspense fallback="Loading...">
      <RTLProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <div className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/tekstil" element={<Textile />} />
                <Route path="/ambalaj" element={<Ambalaj />} />
                <Route path="/ticaret" element={<Ticaret />} />
                <Route path="/katalog" element={<Catalog />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </Router>
      </RTLProvider>
    </Suspense>
  );
}

export default App;
